import { FuseNavigation } from '@fuse/types';
// roles: "PresupuestoApi_GestionVigenciaFiscal",
export const navigation: FuseNavigation[] = [
    {
        id: 'Autenticacion',
        title: 'Autenticación',
        type: 'group',
        icon: 'lock',
        children: [
            {
                id: 'login',
                title: 'Iniciar Sesión',
                type: 'item',
                icon: 'lock',
                url: '/login'
            },
        ]
    },
    {
        id: 'PasivosExigibles',
        title: 'Pasivos exigibles',
        type: 'group',
        icon: 'book',
        children: [
            {
                id: 'DatosBasicos',
                title: 'Datos básicos', 
                type: 'collapsable',
                icon: 'apps',
                children: [
                    {
                        id: 'Vigencia Fiscal',
                        title: 'Vigencia Fiscal',
                        type: 'item',
                        icon: 'calendar_today',
                        url: '/datos-basicos/vigencia-fiscal',
                        roles: 'PasivosExigiblesApi_DatosBasicos'
                    }
                ]
            },  
            {
                id: 'GestionPasivos',
                title: 'Gestión de pasivos exigibles',
                type: 'item',
                icon: 'format_list_numbered',
                url: '/pasivos-exigibles/gestion-pasivos',
                roles: 'PasivosExigiblesApi_GestionPasivos',               
            },
            {
                id: 'DescargaDePasivosExigibles',
                title: 'Generar pasivos exigibles',
                type: 'item',
                icon: 'arrow_downward',
                url: '/pasivos-exigibles/descarga-de-pasivos-exigibles',
                roles: 'PasivosExigiblesApi_GestionPasivos'
            }
        ]
    }
];
